import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    return {
        chartTextStyle: {
            ...theme.fonts.default,
        },

        container: {
        },

        legendTextStyle: {
            ...theme.fonts.default,
        },

        titleTextStyle: {
            ...theme.fonts.default,
        },

        tooltipTextStyle: {
            ...theme.fonts.default,
            color: '#fff',
        },
    };
};

export default getTheme;
